import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import classNames from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useTabsComponent = ({ defaultIndex }) => {
    const [selectedIndex, setSelectedIndex] = useState(defaultIndex);
    return { bind: { selectedIndex, onChange: setSelectedIndex }, selectedIndex, setSelectedIndex }
}

export const TabsComponent = ({ tabs, children, bind,customClassTabList }) => {
    const { t } = useTranslation();
    console.log(customClassTabList)
    return (
        <TabGroup
            {...bind}
            className="max-h-full h-full flex flex-col"
        >
            <TabList className={classNames("flex rounded-t-2 md:overflow-hidden sm-max:overflow-x-auto min-h-12",customClassTabList)}>
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        className={({ selected }) =>
                            classNames(
                                "w-full py-2 text-4 leading-4 font-medium  bg-DarkBlue-700 shadow relative",
                                {
                                    "text-shaiaBlue": selected,
                                    "text-blue-100 hover:bg-white/[0.12] text-white":
                                        !selected,
                                }
                            )
                        }
                    >
                        {t(tab)}
                        {index === bind?.selectedIndex ? (
                            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full h-1 bg-shaiaBlue" />
                        ) : null}
                    </Tab>
                ))}
            </TabList>
            <TabPanels className="mt-2 overflow-y-auto h-full pb-24 px-2">
                {children?.map?.((child, idx) => (
                    <TabPanel className="rounded-xl h-full" key={idx}>{child}</TabPanel>
                ))}
            </TabPanels>
        </TabGroup>
    )
}